import URLProvider from '@/common/services/URLProvider';
import { DriveItemType } from '@/drive/entities/DriveItem/DriveItem.types';
import { DriveItemRequest } from '@/drive/types/DriveItemRequest';
import { PinnedItem, PinnedItemModel, PinnedItemType } from '@/forwarding/entities/PinnedItem/PinnedItem';
import { BaseProductType, ProductType, productTypeToBaseProductType } from '@/product/constants/productTypes';
import { ProductId } from '@/product/entity/Product';

// Narrow view over the original Product — a PinnedProduct only needs these fields.
type ProductOrigin = { id: ProductId; type: ProductType };

export class PinnedProduct implements PinnedItem {
  readonly id: string;
  readonly type = PinnedItemType.Product;
  readonly productId: ProductId;
  readonly productType: BaseProductType;

  constructor(product: ProductOrigin) {
    this.id = `${PinnedItemType.Product}-${product.id}`;
    this.productId = product.id;
    this.productType = productTypeToBaseProductType(product.type);
  }

  getUrl(): string {
    return URLProvider.convertRelativeToAbsolute(
      URLProvider.productDetailPage({ id: this.productId, type: this.productType }),
    );
  }

  toDriveItemRequest(): DriveItemRequest {
    return { type: DriveItemType.Product, productId: this.productId };
  }

  toModel(): PinnedItemModel {
    return { type: this.type, productId: this.productId, productType: this.productType };
  }
}
